<template>
    <section class="resreve">
        <AppReserveIndex />
        <AppReserveForm />
        <AppFooter />
    </section>
</template>

<script>
import AppReserveIndex from '@/components/reserve/Index.vue';
import AppReserveForm from '@/components/reserve/ReserveForm.vue';
import AppFooter from '@/components/footer/Footer';

export default {
    name:'reserve',
    components:{
        AppReserveIndex,
        AppReserveForm,
        AppFooter
    }
}
</script>